/* global axios */
import ApiClient from '../ApiClient';

class CincelAPI extends ApiClient {
  constructor() {
    super('integrations/cincel', { accountScoped: true });
  }

  // Passwordless connect: request an email OTP, then exchange it for a JWT.
  requestOtp({ email }) {
    return axios.post(`${this.url}/request_otp`, { email });
  }

  verifyOtp({ email, otp }) {
    return axios.post(`${this.url}/verify_otp`, { email, otp });
  }

  // One-shot connect with a Personal Access Token — the runtime self-refreshes the JWT,
  // so the admin never has to sign in again.
  connectWithPat({ pat }) {
    return axios.post(`${this.url}/connect_with_pat`, { pat });
  }

  getTeams() {
    return axios.get(`${this.url}/teams`);
  }

  getFolders(teamUuid) {
    return axios.get(`${this.url}/folders`, { params: { team_uuid: teamUuid } });
  }

  getFormTemplates(teamUuid) {
    return axios.get(`${this.url}/form_templates`, {
      params: { team_uuid: teamUuid },
    });
  }

  // Persists the team/folder and auto-registers the per-team signed webhook server-side.
  saveTeamFolder({ teamUuid, folderUuid }) {
    return axios.post(`${this.url}/save_team_folder`, {
      team_uuid: teamUuid,
      default_folder_uuid: folderUuid,
    });
  }

  // --- Signature templates (integrations/cincel/signature_templates) ---

  listTemplates() {
    return axios.get(`${this.url}/signature_templates`);
  }

  createTemplate(data) {
    return axios.post(`${this.url}/signature_templates`, {
      cincel_signature_template: data,
    });
  }

  updateTemplate(id, data) {
    return axios.patch(`${this.url}/signature_templates/${id}`, {
      cincel_signature_template: data,
    });
  }

  deleteTemplate(id) {
    return axios.delete(`${this.url}/signature_templates/${id}`);
  }

  connectForms(id, formIds) {
    return axios.put(`${this.url}/signature_templates/${id}/forms`, {
      form_ids: formIds,
    });
  }
}

export default new CincelAPI();
